const Styles = {
    COLOR_PRIMARY: "#000",
    COLOR_PRIMARY_LIGHT: "var(--primary-light-color)",
    COLOR_SECONDARY: "var(--color-primary)",
    COLOR_SECONDARY_LIGHT: "#ecf1ff",
    COLOR_TEXT_DISABLED: "#787878",
    DEFAULT_BORDER_RADIUS: 4,
    COLOR_RED: "#f00",
    COLOR_RED_LIGHT: "#ff000026",
    COLOR_GREEN: "#06bd31",
    COLOR_GREEN_LIGHT: "#0dea413b"
};

export { Styles };
